export default __webpack_public_path__ + "static/media/stblogo.280a02ac.svg";